import { render } from "./PricingAndMarginDataContentRow.vue?vue&type=template&id=e61aa5b2&scoped=true"
import script from "./PricingAndMarginDataContentRow.vue?vue&type=script&lang=js"
export * from "./PricingAndMarginDataContentRow.vue?vue&type=script&lang=js"

import "./PricingAndMarginDataContentRow.vue?vue&type=style&index=0&id=e61aa5b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e61aa5b2"]])

export default __exports__